<template>
  <div class="login-page">
    <div class="login-content">
      <div class="login-header" :class="{ clickable: !flag, 'has-logo': !!loginLogoUrl }" @click="!flag ? schoolPickerFlag() : null">
        <img v-if="loginLogoUrl" class="school-logo" :src="loginLogoUrl" alt="学校logo" />
        <template v-else>
          <span class="school-name" :class="{ placeholder: !schoolName }">{{ schoolName || '请选择学校' }}</span>
          <van-icon v-if="!flag" name="arrow-down" class="school-arrow" />
        </template>
      </div>
      <van-popup v-model="schoolPicker" position="bottom">
        <van-picker show-toolbar :columns="schoolNameList" @confirm="schoolConfirm" @cancel="schoolPicker = false" />
      </van-popup>
      <div class="login-title">
        <span class="title-bar"></span>
        <span class="title-text">新生入学结果查询</span>
        <span class="title-bar"></span>
      </div>
      <div class="login-form-wrap">
        <van-form class="form_login" @submit="onSubmit" @failed="onFailed" :show-error-message="false">
          <van-field v-model="studentName" name="studentName" input-align="right" label="学生姓名" placeholder="请输入学生姓名" :rules="[{ required: true, message: '请输入学生姓名' }]" />
          <van-field
            v-model="studentNumber"
            name="idNumber"
            input-align="right"
            label="证件号码"
            :maxlength="18"
            placeholder="请输入证件号码"
            :rules="[
              { required: true, message: '请输入证件号码' },
              { pattern, message: '请填写正确的证件号码' }
            ]"
          />
          <van-number-keyboard v-model="studentNumber" :show="idNumberShow" extra-key="X" close-button-text="完成" @blur="idNumberShow = false" />
          <div class="login-btn-wrap">
            <van-button class="login-btn" round native-type="submit" block>查询</van-button>
          </div>
        </van-form>
      </div>
    </div>
    <div class="login-bg-wrap">
      <img class="login-bg-img" :src="loginImgUrl" alt="登录背景" />
    </div>
  </div>
</template>
<script>
import { validEnrollmentStudent, getListBy, getSchoolConfig } from '@/api/home'
export default {
  data() {
    return {
      idNumberShow: false,
      schoolPicker: false,
      flag: false,
      studentName: '',
      studentNumber: '',
      schoolName: '',
      schoolId: -1,
      schoolNameList: [],
      schoolList: [],
      loginLogoUrl: '',
      loginImgUrl: require('../assets/img/dlbg.png'),
      pattern: /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}[\dXx]$/
    }
  },
  created() {
    this.initSchoolId()
    this.getListBy()
    if (this.schoolId != -1) {
      this.getSchoolConfig()
    }
  },
  activated() {
    this.initSchoolId()
    this.getListBy()
    if (this.schoolId != -1) {
      this.getSchoolConfig()
    }
  },
  methods: {
    initSchoolId() {
      let schoolId = this.$route.query.s || this.$route.query.schoolId
      if (!schoolId) {
        schoolId = sessionStorage.getItem('schoolId')
      }
      if (schoolId) {
        sessionStorage.setItem('schoolId', schoolId)
        this.schoolId = schoolId
        this.flag = true
      }
    },
    getSchoolConfig() {
      getSchoolConfig({ schoolId: this.schoolId }).then((res) => {
        if (res.data.code != 0) return
        const data = res.data.data || {}
        this.loginLogoUrl = data.loginLogoUrl || ''
        this.loginImgUrl = data.loginImgUrl || require('../assets/img/dlbg.png')
        if (data.schoolName) {
          this.schoolName = data.schoolName
        }
      })
    },
    onSubmit(val) {
      if (this.schoolId == -1) {
        this.$toast('请选择学校')
        return
      }
      let params = {
        schoolId: this.schoolId,
        studentIdcard: val.idNumber,
        studentName: val.studentName
      }
      validEnrollmentStudent(params).then((res) => {
        if (res.data.code == 0 || String(res.data.code) === '0') {
          let data = res.data.data
          if (data.isFillIn == 0) {
            this.$router.push({
              path: '/instructions',
              query: {
                schoolId: this.schoolId,
                idCard: this.studentNumber,
                studentName: this.studentName
              }
            })
          } else {
            this.$router.push({
              path: '/state',
              query: {
                schoolId: this.schoolId,
                idCard: this.studentNumber,
                studentName: this.studentName
              }
            })
          }
          return false
        }
        this.$toast('未查询到您的信息！')
      })
    },
    onFailed(errorInfo) {
      const errors = (errorInfo && errorInfo.errors) || []
      if (errors.length) {
        this.$toast(errors[0].message)
      }
    },
    schoolPickerFlag() {
      this.schoolPicker = true
    },
    schoolConfirm(val) {
      this.schoolName = val
      this.schoolList.forEach((item) => {
        if (item.name == val) {
          this.schoolId = item.id
        }
      })
      this.schoolPicker = false
      this.getSchoolConfig()
    },
    getListBy() {
      let params = {
        appCode: 'XXRXBM'
      }
      getListBy(params).then((res) => {
        let data = res.data.data.dataList
        this.schoolNameList = []
        this.schoolList = res.data.data.dataList
        if (this.schoolId != -1) {
          data.forEach((item) => {
            if (item.id == this.schoolId) {
              this.schoolName = item.name
            }
          })
        }
        data.forEach((item) => {
          this.schoolNameList.push(item.name)
        })
      })
    }
  }
}
</script>
<style scoped>
.login-page {
  box-sizing: border-box;
  min-height: 100vh;
  width: 100%;
  background: #fff;
  position: relative;
}
.login-content {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  padding: 1.35rem 0 2.6rem;
}
.login-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem 0.35rem;
}
.login-header.has-logo {
  padding: 0 0.5rem 0.45rem;
}
.login-header.clickable {
  cursor: pointer;
}
.school-logo {
  width: 100%;
  height: auto;
  max-height: 1.35rem;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
.school-name {
  font-size: 0.36rem;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  text-align: center;
}
.school-name.placeholder {
  color: #999;
  font-weight: 400;
}
.school-arrow {
  margin-left: 0.15rem;
  color: #999;
  font-size: 0.35rem;
}
.login-title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.55rem 0.5rem 0.75rem;
}
.title-bar {
  width: 0.08rem;
  height: 0.42rem;
  background: #1a3260;
  border-radius: 0.04rem;
}
.title-text {
  margin: 0 0.26rem;
  font-size: 0.44rem;
  font-weight: 600;
  color: #1a3260;
  letter-spacing: 0.02rem;
}
.login-form-wrap {
  padding: 0 0.5rem;
}
.form_login >>> .van-cell {
  box-sizing: border-box;
  height: 1.2rem;
  min-height: 1.2rem;
  padding: 0 0.4rem;
  margin-bottom: 0.42rem;
  border: 1px solid #dcdfe6;
  border-radius: 0.55rem;
  background: #fff;
  display: flex;
  align-items: center;
}
.form_login >>> .van-cell::after {
  display: none;
}
.form_login >>> .van-field__label {
  width: 2rem;
  color: #333;
  font-weight: 500;
  font-size: 0.37rem;
}
.form_login >>> .van-field__control {
  font-size: 0.37rem;
  color: #333;
}
.form_login >>> .van-field__control::placeholder {
  color: #c0c4cc;
}
.login-btn-wrap {
  margin: 0.55rem 0 0;
}
.login-btn {
  background: #1a3260 !important;
  border: none !important;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.42rem;
  color: #fff !important;
}
.login-bg-wrap {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 1;
  line-height: 0;
  pointer-events: none;
}
.login-bg-img {
  width: 100%;
  max-height: 38vh;
  height: auto;
  display: block;
  object-fit: cover;
  object-position: bottom center;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue